import Vue from 'vue';
import VueRouter from 'vue-router';
import VueMeta from 'vue-meta';
import monitor from '@baidu/fe-monitor';

import App from './App.vue';
import router from './router';

import './plugins/element-ui';

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(VueMeta, {
    refreshOnceOnNavigation: true
});
monitor.init();

new Vue({
    render: h => h(App),
    router
}).$mount('#app');
